import React from 'react';
import AssetsGroupComponent from "./AssetsGroupComponent";
import {ListItem, ListItemIcon, ListItemText, Typography} from "@material-ui/core";
import List from "@material-ui/core/List";
import CloudDoneIcon from '@material-ui/icons/CloudDone';

export default function ApplicationComponent(applications, classes) {

    return applications.map(application =>
        <List component={application.id}>
            <ListItem className={classes.rowHeader}>
                <ListItemIcon>
                    <CloudDoneIcon/>
                </ListItemIcon>
                <ListItemText secondary="APPLICATION:" className={classes.label}/>
                <ListItem>
                    <Typography className={classes.applicationIdText}>
                        {application.id.toUpperCase()}
                    </Typography>
                </ListItem>
            </ListItem>
            <ListItem>
                {AssetsGroupComponent(application.assets, classes)}
            </ListItem>
            <br/>
        </List>
    )
}